import { CompanyInformationTabs } from './types';
import CompanyNamePanel from './panels/CompanyName';
import CompanyLogoPanel from './panels/CompanyLogo';
import CompanyAddressesPanel from './panels/CompanyAddresses';

export const SIDEBAR_WIDTH = 180;

export const COMPANY_INFORMATION_AUDIT_PARENT_KEYS = ['name', 'addresses', 'whiteLabeling'];

export const panels = [
  {
    key: CompanyInformationTabs.Name,
    title: 'administration.company.information.sidebar.name',
    component: CompanyNamePanel,
  },
  {
    key: CompanyInformationTabs.Logo,
    title: 'administration.company.information.sidebar.logo',
    component: CompanyLogoPanel,
  },
  {
    key: CompanyInformationTabs.Addresses,
    title: 'administration.company.information.sidebar.addresses',
    component: CompanyAddressesPanel,
  },
];
